import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/toPromise';

import { WsLimit } from '../wslimit/wslimit.service';

import { Fmt } from '../../fmt.service';

@Injectable()
export class WsUsageService {
    constructor(
        private _http: Http,
        public _fmt: Fmt,
    ) {}

    LoadWsUsagesList<T>(params: WsUsageListParams): Observable<any> {
        // var params = new URLSearchParams();

        return this._fmt.HttpGet<T>('/api/v1/get_workspace_usage_list_with_search', params, 0);
    }
}

// WsUsageListParams is search params for get_workspace_usage_list_with_search
export interface WsUsageListParams {
    w_id: string;
    name: string;
    page: number;
    per_page: number;
}

export interface WsUsageList {
    Columns: string[];
}
